import React from 'react';
import { GridLayout, GridItem } from '@emorg-prd/standard-react';

export type GridVariant =
	| 'halves'
	| '2up'
	| '1-2-1'
	| '3up'
	| '1-to-3up'
	| '4up'
	| '1-2-4up'
	| '5up'
	| '6up'
	| '2-3-6up';

interface GridProps extends Omit<React.ComponentProps<typeof GridLayout>, 'type' | 'children'> {
	variant?: GridVariant;
	className?: string;
	children?: React.ReactNode;
}

export interface GridItemProps extends React.HTMLAttributes<HTMLDivElement> {
	/** children of the container */
	children?: React.ReactNode;
	/** Additional css classes to append to the outer element */
	className?: string;
}

// Create a wrapper for GridItem that matches with GridItemProps
const GridItemWrapper: React.FC<GridItemProps> = ({ children, className, ...props }) => {
	return (
		<GridItem optionalClass={className} {...props}>
			{children}
		</GridItem>
	);
};

const Grid: React.FC<GridProps> & { Item: typeof GridItemWrapper } = (props) => {
	return (
		<GridLayout {...props} type={`em-l-grid--${props.variant || 'halves'}`} optionalClass={props.className}>
			{props.children}
		</GridLayout>
	);
};

// Add Grid.Item as static property
Grid.Item = GridItemWrapper;

export { Grid };
